
export const monthsName = [
        {
            "name":"Jan",
            "number":1
        },
        {
            "name":"Feb",
            "number":2
        },
        {
            "name":"March",
            "number":3
        },
        {
            "name":"April",
            "number":4
        },
        {
            "name":"May",
            "number":5
        },
        {
            "name":"June",
            "number":6
        },
        {
            "name":"July",
            "number":7
        },
        {
            "name":"August",
            "number":8
        },
        {
            "name":"Sept.",
            "number":9
        },
        {
            "name":"Oct.",
            "number":10
        },
        {
            "name":"Nov.",
            "number":11
        },
        {
            "name":"Dec.",
            "number":12
        },
    ]
